//GeneratorFlag:[NoChange]
import ProcessGroup from './process-group';

export default {ProcessGroup}
export{ProcessGroup}